exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#humanBody, div {\n  float: left; }\n\np {\n  display: none;\n  margin-top: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/widget-human-body/widget-human-body.component.scss
// module id = ../../../../../src/app/widget-human-body/widget-human-body.component.scss
// module chunks = main